export default "<video\nwidth=\"100%\"\n[src]=\"src\" controls controlsList=\"nodownload\" (contextmenu)=\"onRightClick($event)\" ></video>\n";